import { render, staticRenderFns } from "./CatalogoAccesos.vue?vue&type=template&id=7caa9740&scoped=true&"
import script from "./CatalogoAccesos.vue?vue&type=script&lang=js&"
export * from "./CatalogoAccesos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caa9740",
  null
  
)

export default component.exports